import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  AUTH_PREFIX_PATH,
  APP_PREFIX_PATH,
  AUTHENTICATED_ENTRY,
  UNAUTHENTICATED_ENTRY,
  REDIRECT_URL_KEY,
} from "configs/AppConfig";

const CHANGE_PASSWORD_PATH = `${APP_PREFIX_PATH}/hrm/setting-account/change-password`;

const ProtectedRoute = () => {
  const { token, mustChangePassword } = useSelector((state) => state.auth);
  const location = useLocation();
  if (!token) {
    // Sau khi đổi mật khẩu ở màn buộc đổi -> signOut ngay tại /change-password.
    // KHÔNG lấy chính trang đổi mật khẩu làm redirect sau đăng nhập, nếu không
    // đăng nhập lại sẽ quay về đây thay vì vào dashboard (dù cờ đã tắt).
    const redirectTarget = location.pathname.includes(CHANGE_PASSWORD_PATH)
      ? AUTHENTICATED_ENTRY
      : `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${redirectTarget}`}
        replace
      />
    );
  }
  // Buộc đổi mật khẩu -> chặn mọi route protected khác, chỉ cho ở màn đổi mật khẩu.
  if (mustChangePassword && !location.pathname.includes(CHANGE_PASSWORD_PATH)) {
    return <Navigate to={`${CHANGE_PASSWORD_PATH}?mustChange=1`} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
